import { Box, Typography } from "@mui/material";
import CarsList from "./CarsList";
import { baseImageUrl } from "../../../api";
import CarContainer1, { LiveAuctionCard } from "./CarContainer1";
import theme from "../../../theme";

const SimilarCars = ({
  cars = []
}) => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="h1"
        sx={{
          textAlign: "center",
          fontSize: "1.5rem",
          color: theme.palette.primary.main
        }}
      >
        Similar Cars
      </Typography>
      <CarsList
        isUpcomingCar={true}
        cars={cars?.map?.((vehicle) => {
          return {
            ...vehicle,
            vin: vehicle?.VIN,
            year: vehicle?.Year,
            make: vehicle?.Make,
            model: vehicle?.Model,
            odometer: vehicle?.Mileage,
            image: vehicle?.Exterior_Image
              ? `${baseImageUrl}/${vehicle?.Vehicle_Id}/${vehicle?.Exterior_Image}`
              : ``,
          };
        })}
        onClick={(vehicle) => {
          console.log(vehicle, "CarsList")
          if (onCarClick) {
            onCarClick(vehicle);
          }
        }}
        Component={CarContainer1}
        ChildComponent={LiveAuctionCard}
        showCancelAuction={false}
        showRemainingTime={false}
        showMenuButton={false}
        showSimilarCarsButton={false}
        cardWidth={"45%"}
        cardMinWidth={"none"}
      />
    </Box>
  );
};

export default SimilarCars;